
const AutoPartsDetails =[

    { 
         name : " Toyota Fortuner 2016-2021 PVC Cotton Fabric",
         description :"Imported  Non Woven PVC + Cotton Fabric Top Cover Multi Layer Protection Water Proof, Dust Proof, Scratch Proof Easy Take On/OffZipper + Mirror Pockets for Rs 4500",
        pic:require("./images/fabric.jpg"),
        },
    
    {
         name : "Gladiator Car Scratch Remover With Microfiber",
         description :"Gladiator Scratch Remover helps remove fine scratches, swirls and haze from all auto paint finishes. It can also remove  paint marks and water spotting quickly and easily only in Rs 999",
        pic:require("./images/gladitor.jpg")
    },

    {
         name : "Solar Powered Aeroplane Car Air Freshener",
         description :"Car Dashboard Solar Decoration Aircraft Model Plane Air Freshener is best for Decoration and Perfume. most importantly, this perfume uses solar energy as the power source to drive the propeller to rotate only in Rs 1500",
        pic:require("./images/airconditoner.jpg")
    },
 
    
    {
         name : "Nexen Tire N-Blue Eco 225/50R17",
         description :"Nexen N'Blue Eco is an economy-class summer tyre intended for daily driving. The model was developed using a rubber compound featuring an excellent flexibility in a wide range of temperatures only for 2000.",
        pic:require("./images/tyre.jpg")
    },

    
    {
        name : "PakWheels All Purpose Cleaner ",
        description :"Another motorbike manufactured in Italy, MV Agusta F4 1000 R offers wonderful features like rare shock absorber which make it to adjust easily either in low and high speed.",
       pic:require("./images/cleaner.jpg")
   },

   
   {
    name : "Honda Civic 2022 Diamond Cut Floor Mats Black Red ",
    description :"Neat Stitching, Fits exactly to the size of the car , Can be cleaned easily, New Design car mat available at your door step with free delievery in Rs 3000.Cash on delivery is available",
   pic:require("./images/mat.jpg")
},


{
    name : "Toyota Red Chrome Seat Safety Belt Clip",
    description :"Material: Steel, Package Content: 2PCS Buckle Clip Clamp, Durable & Comfortable, Rust-proof & Wear-resistant with high premium  quality in just Rs 300 without delivery charges.",
   pic:require("./images/clip.jpg")
},


{
    name : "Microfiber Towel Yellow And Grey 30cm x 30cm",
    description :"The Microfiber Cloth or Towel is a soft towel or cloth piece which helps to improve your cleaning efforts in your daily routine. Ultra soft, non-abrasive microfiber towel or microfiber cleaning cloth in just Rs 150",
   pic:require("./images/towel.jpg")
},
    ]
    
export function getAutoPartsDetails(){return AutoPartsDetails;}
    
    
    